// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Pervasives = require("rescript/lib/js/pervasives.js");
var JsxRuntime = require("react/jsx-runtime");
var Utils$ReactHooksTemplate = require("../common/utils.res.js");
var Action$ReactHooksTemplate = require("./Action.res.js");
var Survey$ReactHooksTemplate = require("./survey.res.js");
var Question$ReactHooksTemplate = require("./Question.res.js");
var ThankYou$ReactHooksTemplate = require("./ThankYou.res.js");
var OptionGroup$ReactHooksTemplate = require("../common/optionGroup.res.js");
var RedirectionUrl$ReactHooksTemplate = require("./redirectionUrl.res.js");
var TicketCategory$ReactHooksTemplate = require("../tickets/ticketCategory.res.js");
var FilteredSelectBox$ReactHooksTemplate = require("./FilteredSelectBox.res.js");

function ActionForm(props) {
  var targetQuestions = props.targetQuestions;
  var thankYous = props.thankYous;
  var updateLogicAction = props.updateLogicAction;
  var action = props.action;
  var category = props.category;
  var jumpExists = props.jumpExists;
  var survey = props.survey;
  var questionOptions = {
    TAG: "Questions",
    _0: Belt_List.map(Belt_List.keep(Belt_List.mapWithIndex(Survey$ReactHooksTemplate.questions(survey), (function (i, q) {
                    return [
                            i,
                            q
                          ];
                  })), (function (param) {
                var q = param[1];
                return List.exists((function (x) {
                              return Caml_obj.equal(Question$ReactHooksTemplate.uuid(x), Question$ReactHooksTemplate.uuid(q));
                            }), targetQuestions);
              })), (function (param) {
            var q = param[1];
            return [
                    {
                      TAG: "Question",
                      _0: q
                    },
                    {
                      TAG: "HtmlElement",
                      _0: OptionGroup$ReactHooksTemplate.optionLabelElement("Q" + String(param[0] + 1 | 0), Utils$ReactHooksTemplate.stripHtml(Question$ReactHooksTemplate.text(q)))
                    }
                  ];
          }))
  };
  var thankYouOptions = {
    TAG: "ThankYous",
    _0: Belt_List.mapWithIndex(thankYous, (function (i, t) {
            return [
                    t,
                    {
                      TAG: "HtmlElement",
                      _0: OptionGroup$ReactHooksTemplate.optionLabelElement("T" + String(i + 1 | 0), Utils$ReactHooksTemplate.stripHtml(ThankYou$ReactHooksTemplate.text(t)))
                    }
                  ];
          }))
  };
  var redirectionUrlOptions = {
    TAG: "RedirectionUrls",
    _0: Belt_List.mapWithIndex(survey.redirectionUrls, (function (i, t) {
            return [
                    t,
                    {
                      TAG: "HtmlElement",
                      _0: OptionGroup$ReactHooksTemplate.optionLabelElement("R" + String(i + 1 | 0), RedirectionUrl$ReactHooksTemplate.name(t))
                    }
                  ];
          }))
  };
  var ticketGenerationOptions = {
    TAG: "TicketCategories",
    _0: Belt_List.mapWithIndex(survey.ticketCategories, (function (i, t) {
            return [
                    t,
                    {
                      TAG: "HtmlElement",
                      _0: OptionGroup$ReactHooksTemplate.optionLabelElement("TC" + String(i + 1 | 0), TicketCategory$ReactHooksTemplate.name(t))
                    }
                  ];
          }))
  };
  var match = Action$ReactHooksTemplate.actionType(action);
  var options;
  switch (match.TAG) {
    case "Skip" :
    case "Jump" :
        options = {
          hd: questionOptions,
          tl: {
            hd: thankYouOptions,
            tl: /* [] */0
          }
        };
        break;
    case "Redirection" :
        options = {
          hd: redirectionUrlOptions,
          tl: /* [] */0
        };
        break;
    case "TicketGeneration" :
        options = {
          hd: ticketGenerationOptions,
          tl: /* [] */0
        };
        break;
    
  }
  var skipTarget = Action$ReactHooksTemplate.actionType(action);
  var selectedOption;
  switch (skipTarget.TAG) {
    case "Skip" :
        var skipTarget$1 = skipTarget._0;
        if (skipTarget$1.TAG === "Questions") {
          var qs = skipTarget$1._0;
          selectedOption = questionOptions.TAG === "Questions" ? ({
                TAG: "Questions",
                _0: Belt_List.keep(questionOptions._0, (function (param) {
                        var a = param[0]._0;
                        return List.exists((function (q) {
                                      return Caml_obj.equal(Question$ReactHooksTemplate.uuid(q), Question$ReactHooksTemplate.uuid(a));
                                    }), qs);
                      }))
              }) : ({
                TAG: "Questions",
                _0: /* [] */0
              });
        } else {
          var ts = skipTarget$1._0;
          selectedOption = thankYouOptions.TAG === "ThankYous" ? ({
                TAG: "ThankYous",
                _0: Belt_List.keep(thankYouOptions._0, (function (param) {
                        var x = param[0];
                        return List.exists((function (t) {
                                      return Caml_obj.equal(ThankYou$ReactHooksTemplate.uuid(t), ThankYou$ReactHooksTemplate.uuid(x));
                                    }), ts);
                      }))
              }) : ({
                TAG: "ThankYous",
                _0: /* [] */0
              });
        }
        break;
    case "Jump" :
        var jumpTarget = skipTarget._0;
        if (jumpTarget.TAG === "Question") {
          var q = jumpTarget._0;
          selectedOption = questionOptions.TAG === "Questions" ? ({
                TAG: "Questions",
                _0: Belt_List.keep(questionOptions._0, (function (param) {
                        return Caml_obj.equal(Question$ReactHooksTemplate.uuid(q), Question$ReactHooksTemplate.uuid(param[0]._0));
                      }))
              }) : ({
                TAG: "Questions",
                _0: /* [] */0
              });
        } else {
          var t = jumpTarget._0;
          selectedOption = thankYouOptions.TAG === "ThankYous" ? ({
                TAG: "ThankYous",
                _0: Belt_List.keep(thankYouOptions._0, (function (param) {
                        return Caml_obj.equal(ThankYou$ReactHooksTemplate.uuid(t), ThankYou$ReactHooksTemplate.uuid(param[0]));
                      }))
              }) : ({
                TAG: "ThankYous",
                _0: /* [] */0
              });
        }
        break;
    case "Redirection" :
        var redirectionUrl = skipTarget._0;
        selectedOption = redirectionUrl !== undefined && redirectionUrlOptions.TAG === "RedirectionUrls" ? ({
              TAG: "RedirectionUrls",
              _0: Belt_List.keep(redirectionUrlOptions._0, (function (param) {
                      return Caml_obj.equal(RedirectionUrl$ReactHooksTemplate.id(redirectionUrl), RedirectionUrl$ReactHooksTemplate.id(param[0]));
                    }))
            }) : ({
              TAG: "RedirectionUrls",
              _0: /* [] */0
            });
        break;
    case "TicketGeneration" :
        var ticketCategory = skipTarget._0;
        selectedOption = ticketCategory !== undefined && ticketGenerationOptions.TAG === "TicketCategories" ? ({
              TAG: "TicketCategories",
              _0: Belt_List.keep(ticketGenerationOptions._0, (function (param) {
                      return Caml_obj.equal(TicketCategory$ReactHooksTemplate.id(ticketCategory), TicketCategory$ReactHooksTemplate.id(param[0]));
                    }))
            }) : ({
              TAG: "TicketCategories",
              _0: /* [] */0
            });
        break;
    
  }
  var handleOptionChange = function (updatedOptions) {
    var match = Action$ReactHooksTemplate.actionType(action);
    var tmp;
    switch (match.TAG) {
      case "Skip" :
          switch (updatedOptions.TAG) {
            case "Questions" :
                var questions = List.map((function (param) {
                        return param[0]._0;
                      }), updatedOptions._0);
                tmp = Action$ReactHooksTemplate.setActionType(action, {
                      TAG: "Skip",
                      _0: {
                        TAG: "Questions",
                        _0: questions
                      }
                    });
                break;
            case "ThankYous" :
                var thankYous = List.map((function (param) {
                        return param[0];
                      }), updatedOptions._0);
                tmp = Action$ReactHooksTemplate.setActionType(action, {
                      TAG: "Skip",
                      _0: {
                        TAG: "ThankYous",
                        _0: thankYous
                      }
                    });
                break;
            default:
              tmp = action;
          }
          break;
      case "Jump" :
          switch (updatedOptions.TAG) {
            case "Questions" :
                var match$1 = Belt_List.head(updatedOptions._0);
                tmp = match$1 !== undefined ? Action$ReactHooksTemplate.setActionType(action, {
                        TAG: "Jump",
                        _0: {
                          TAG: "Question",
                          _0: match$1[0]._0
                        }
                      }) : action;
                break;
            case "ThankYous" :
                var match$2 = Belt_List.head(updatedOptions._0);
                tmp = match$2 !== undefined ? Action$ReactHooksTemplate.setActionType(action, {
                        TAG: "Jump",
                        _0: {
                          TAG: "ThankYou",
                          _0: match$2[0]
                        }
                      }) : action;
                break;
            default:
              tmp = action;
          }
          break;
      case "Redirection" :
          switch (updatedOptions.TAG) {
            case "RedirectionUrls" :
                var match$3 = Belt_List.head(updatedOptions._0);
                tmp = match$3 !== undefined ? Action$ReactHooksTemplate.setActionType(action, {
                        TAG: "Redirection",
                        _0: match$3[0]
                      }) : action;
                break;
            default:
              tmp = action;
          }
          break;
      case "TicketGeneration" :
          if (updatedOptions.TAG === "TicketCategories") {
            var match$4 = Belt_List.head(updatedOptions._0);
            tmp = match$4 !== undefined ? Action$ReactHooksTemplate.setActionType(action, {
                    TAG: "TicketGeneration",
                    _0: match$4[0]
                  }) : action;
          } else {
            tmp = action;
          }
          break;
      
    }
    Curry._1(updateLogicAction, tmp);
  };
  var handleActionTypeChange = function ($$event) {
    var action$p = Utils$ReactHooksTemplate.formTargetValue($$event);
    var tmp;
    switch (action$p) {
      case "Jump" :
          tmp = List.length(targetQuestions) === 0 ? Action$ReactHooksTemplate.emptyAction({
                  TAG: "ThankYou",
                  _0: List.hd(thankYous)
                }) : Action$ReactHooksTemplate.emptyAction({
                  TAG: "Question",
                  _0: List.hd(targetQuestions)
                });
          break;
      case "Skip" :
          tmp = List.length(targetQuestions) === 0 ? Action$ReactHooksTemplate.emptySkipAction({
                  TAG: "ThankYous",
                  _0: {
                    hd: List.hd(thankYous),
                    tl: /* [] */0
                  }
                }) : Action$ReactHooksTemplate.emptySkipAction({
                  TAG: "Questions",
                  _0: {
                    hd: List.hd(targetQuestions),
                    tl: /* [] */0
                  }
                });
          break;
      default:
        tmp = Pervasives.failwith("Not Valid Action Type");
    }
    Curry._1(updateLogicAction, tmp);
  };
  var match$1 = Action$ReactHooksTemplate.actionType(action);
  var enableMultipleSelection;
  enableMultipleSelection = match$1.TAG === "Skip" ? true : false;
  var stringOfActionType = Action$ReactHooksTemplate.stringOfActionType(action);
  var hideActionFromSelect = function (actionName) {
    switch (category) {
      case "Survey" :
          switch (actionName) {
            case "Jump" :
                return jumpExists;
            case "Skip" :
                return false;
            default:
              return true;
          }
      case "Redirection" :
          if (actionName === "Redirection") {
            return false;
          } else {
            return true;
          }
      case "TicketGeneration" :
          if (actionName === "Ticket Generation") {
            return false;
          } else {
            return true;
          }
      
    }
  };
  var tmp;
  switch (category) {
    case "Survey" :
        tmp = "Select Question/Thankyou";
        break;
    case "Redirection" :
        tmp = "Select Redirection Url";
        break;
    case "TicketGeneration" :
        tmp = "Select Ticket Category";
        break;
    
  }
  return JsxRuntime.jsx("div", {
              children: JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx("div", {
                            children: "THEN",
                            className: "flex text-base font-semibold text-darkcharcoal items-center w-1/12 pt-20-px"
                          }),
                      JsxRuntime.jsx("div", {
                            children: JsxRuntime.jsxs("div", {
                                  children: [
                                    JsxRuntime.jsx("div", {
                                          children: "Action",
                                          className: "w-48-px h-20-px font-normal text-xs text-aurometalsaurus"
                                        }),
                                    JsxRuntime.jsx("select", {
                                          children: $$Array.of_list(Belt_List.map(Action$ReactHooksTemplate.actions, (function (xs) {
                                                      var selected = xs.toLocaleLowerCase() === stringOfActionType;
                                                      return JsxRuntime.jsx("option", {
                                                                  children: xs,
                                                                  className: "text-left bg-white-300 px-2 py-1 hover:bg-gray-300 " + (
                                                                    hideActionFromSelect(xs) ? "hidden" : "visible"
                                                                  ),
                                                                  selected: selected,
                                                                  value: xs
                                                                }, xs);
                                                    }))),
                                          className: "min-h-38-px px-2 py-1 rounded bg-white border cursor-pointer\n                      border-gray-300 focus:border-gray-600 text-xs w-full",
                                          placeholder: "Select Action",
                                          onChange: handleActionTypeChange
                                        })
                                  ],
                                  className: "flex flex-col w-full"
                                }),
                            className: "flex items-center w-3/12"
                          }),
                      enableMultipleSelection ? JsxRuntime.jsx("div", {
                              className: "w-1/12 less-gap-2"
                            }) : JsxRuntime.jsx("div", {
                              children: "TO",
                              className: "flex text-base font-semibold text-darkcharcoal items-center w-1/12 pt-20-px justify-center less-gap-2"
                            }),
                      JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx("div", {
                                    className: "h-20-px font-normal text-xs text-aurometalsaurus"
                                  }),
                              JsxRuntime.jsx(FilteredSelectBox$ReactHooksTemplate.make, {
                                    options: options,
                                    placeholder: tmp,
                                    onChange: handleOptionChange,
                                    className: "py-1 px-2 rounded bg-white border border-gray-300\n                     focus:border-gray-600 text-xs min-h-38-px",
                                    selectedOption: selectedOption,
                                    multipleSelect: enableMultipleSelection
                                  })
                            ],
                            className: "w-7/12"
                          })
                    ],
                    className: "flex justify-between gap-2"
                  }),
              className: "bg-white w-full"
            });
}

var make = ActionForm;

exports.make = make;
/* react/jsx-runtime Not a pure module */
